export default "__VITE_ASSET__CbYboSFY__"